// extracted by mini-css-extract-plugin
export default {"tupacGrid":"jj-z","tupacHeader":"kj-z","tupacHeader2":"lj-z","tupacMenu":"mj-z","tupacMenu2":"nj-z","tupacMain":"oj-z","tupacMain2":"pj-z"};